export function trimFilters(filters) {
  const trimedFilters = {...filters};
  Object.keys(trimedFilters).forEach(filterKey => {
    if (!trimedFilters[filterKey]) return;
    trimedFilters[filterKey] =
      typeof trimedFilters[filterKey] === "string" ? trimedFilters[filterKey]?.trim() : trimedFilters[filterKey];
  });
  return trimedFilters;
}
